import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import API, { handleApiError } from '../../../lib/api';
import EditLenderView from './View';
import LenderNotFound from '../LenderNotFound';

import Loading from '../../common/Loading';

function EditLenderContainer({ id }) {
  const lenderId = id;
  // Data state to store the users data. Its initial value is an empty array
  const [data, setData] = useState([]);
  const [displayError, setDisplayError] = React.useState();
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    await API.get(`lenders/${lenderId}`)
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        handleApiError({ error, setDisplayError });
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (!lenderId) {
      return;
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lenderId]);

  if (isLoading) return <Loading />;
  return data && data._id ? (
    <EditLenderView data={data} refetchData={fetchData} />
  ) : (
    <LenderNotFound id={lenderId} displayError={displayError} />
  );
}

EditLenderContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default EditLenderContainer;
